import React from "react";
import ProgramCards from "./programCards";

const ExplorePrograms = () => {
  return (
    <section id="programs" className="p-8 bg-gray-100 text-center pt-24">
      <h2 className="text-4xl font-bold text-custom-pink mb-4">
        Courses Offered by JRIIT
      </h2>
      <span className="inline-block border-solid  border-b-4 border-gold mb-4 w-28 h-2"></span>
      <p className="text-lg text-gray-700 mb-8">
        Discover a range of courses designed to ignite your potential and
        prepare you for success in the future.
      </p>
      <div className="flex justify-center space-x-6">
        <ProgramCards />
      </div>
      {/* <span className="block border-dotted border-l-4 border-gold mb-4 w-28 h-24 mx-auto md:ml-auto md:mr-0 lg:ml-[925px] bg-gray-100"></span> */}
    </section>
  );
};

export default ExplorePrograms;
